import validator from 'validator'
import ValidatorProvider from './ValidatorProvider'

export const isCubaCI = (value = '') => {
  if (!value) return true; //avoid empty values

  if (validator.isLength(value, 11, 11) && value.match(/^\d{11}$/)) {
    const month = Number(value.substring(2, 4));
    const day = Number(value.substring(4, 6));
    if (month > 12 || month < 1)
      return false
    return !(day > 31 || day < 1);

  }
  return false;
}
export const CubaCIRuler = {

  validator(rule, value) {
    if (isCubaCI(value, 11, 11) || !value || !value.trim()) {
      return Promise.resolve()
    }

    const message = rule.message || 'invalidCubaCI'

    return Promise.reject(ValidatorProvider.t(message))
  },

}

/**
 * Código REEUP debe tener el formato: NNN.N.NNNNN o NNN.N.NNNNNN
 * @param value
 * @returns {*}
 */
export const isREEUPCode = (value = '') => {
  return validator.isLength(value, 11, 12) && !!value.match(/^[\d]{3}.\d.[\d]{5,6}$/)
}

export const CubaREEUPCodeRuler = {

  validator(rule, value) {
    if (isREEUPCode(value) || !value || !value.trim()) {
      return Promise.resolve()
    }

    const message = rule.message || 'invalidCubaREEUPCode'

    return Promise.reject(ValidatorProvider.t(message))
  },

}
